<div class="modal-header">
  <h4 class="modal-title" translate>EXPORT_EDI_PRICAT</h4>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="col-12">
    <lib-gung-date-picker
      [currentselectedDate]="validFromDate"
      (selectedDate)="validFromDate = $event"
      label="CONTEXT_PARAMS_VALIDFROMDATE"
    ></lib-gung-date-picker>

    <lib-gung-date-picker
      [currentselectedDate]="validToDate"
      (selectedDate)="validToDate = $event"
      label="CONTEXT_PARAMS_VALIDTODATE"
    ></lib-gung-date-picker>

    <lib-gung-date-picker
      [currentselectedDate]="preOrderToDate"
      (selectedDate)="preOrderToDate = $event"
      label="CONTEXT_PARAMS_PREORDERTODATE"
    ></lib-gung-date-picker>

    <div class="form-check pb-2">
      <input type="checkbox" class="form-check-input" id="sendToFtp" [(ngModel)]="sendToFtp">
      <label class="form-check-label" for="sendToFtp" translate>SEND_TO_FTP</label>
    </div>

    <div class="alert alert-info" role="alert" *ngIf="isValid()">
      <span translate>PRICAT_WILL_BE_EXPORTED</span>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="btn-group btn-group-justified w-100">
    <button class="btn btn-secondary" (click)="cancel()" translate>CANCEL</button>
    <button class="btn btn-primary" [disabled]="!isValid()" (click)="confirm()" translate>EXPORT</button>
  </div>
</div>
